import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable } from 'rxjs';
import { ReportParams } from './report-params';
import { ReportProgress } from '../common/interface/report-progress';

@Injectable()
export class ExportReportService extends EntityService<any> {

  constructor(private _httpClient: HttpClient) {
    super(_httpClient);
    this.resource = '/api/report-executor';
  }

  executeAsyncReport(params: ReportParams[], idRelatorio: string): Observable<ReportProgress> {
    return this.httpClient.post({
      resource: `${this.resource}/${idRelatorio}`,
      body: params,
      disableSpinner: true
    });
  }

}
